import axios, { AxiosResponse } from "axios";
import { getUserToken } from "utils/getToken";

export const ApiFinancialGraphql = process.env.REACT_APP_API_FINANCIAL_URL;

export const ApiFinancialInstance = axios.create({
  baseURL: ApiFinancialGraphql,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Authorization: getUserToken(),
  },
  method: "POST",
});

export async function ApiFinancialRequest<responseDataType = any>({
  query,
  variables,
  headers,
  data = {},
}: {
  query: string;
  variables?: { [key: string]: any };
  headers?: { [key: string]: string }; // Adicione a opção de cabeçalhos como um parâmetro
  data?: { [key: string]: any };
}): Promise<AxiosResponse<{ data?: responseDataType; errors?: Error[] }>> {
  return ApiFinancialInstance.request<{
    data?: responseDataType;
    errors?: Error[];
  }>({
    data: {
      query,
      variables,
      ...data,
    },
    headers: {
      ...headers,
      Authorization: localStorage.getItem("UserToken"),
    }, // Passe os cabeçalhos para a requisição
  });
}

export interface DataState<DataType = any> {
  loading?: boolean;
  error?: Error;
  data?: DataType;
}

export async function ApiFinancialWithSetData<T = any>({
  query,
  variables,
  setData,
  headers, // Adicione a opção de cabeçalhos como um parâmetro
}: {
  query: string;
  variables?: { [key: string]: any };
  setData: (data: DataState<T>) => void;
  headers?: { [key: string]: string }; // Adicione a opção de cabeçalhos como um parâmetro
}): Promise<DataState<T>> {
  return ApiFinancialRequest<T>({ query, variables, headers })
    .then((response) => {
      if (!response?.data?.data) {
        const respError: DataState<T> = {
          loading: false,
          error: response?.data?.errors?.[0] || new Error("mediaFiles not found"),
          data: undefined,
        };
        setData(respError);
        return respError;
      }
      const respSuccess: DataState<T> = {
        error: undefined,
        loading: false,
        data: response.data.data,
      };
      setData(respSuccess);
      return respSuccess;
    })
    .catch((error) => {
      console.error(error);
      const respError: DataState<T> = {
        loading: false,
        error,
        data: undefined,
      };
      setData(respError);
      return respError;
    });
}
